import { Component, computed, inject } from '@angular/core';
import { MobileFrameService, MobilePagePart } from '@eforall/mobile';


@Component({
	selector: 'policies-page',
	imports: [
		MobilePagePart,
	],
	templateUrl: './policies.page.html'
})

export class PoliciesPage {
	private frame = inject(MobileFrameService);

	constructor() {
		this.frame.setUrlMetadata({
			url: '/policies',
			backUrl: '/',
			pageName: computed(() => `Policies`),
			headerText: computed(() => `Policies`),
		});
	}

}